var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgType(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.001,
    viewBox: "0 0 20 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29325",
    d: "M17.363 422H2.637L0 425.253h20zm-14.14 1.084h13.554l.879 1.084H2.344z",
    transform: "translate(0 -405.252)",
    style: {
      fill: "#323233"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29326",
    d: "M17.656 5.994V0H2.344v5.994H0v9.67h20v-9.67zM3.516 1.2h12.968v4.794h-1.171V2.4H4.688V6H3.516zm10.625 2.4V6H5.859V3.6zM7.057 14.464H3.516V9.59h3.541v4.875zm4.714 0H8.229V9.59h3.542zm4.714 0h-3.542V9.59h3.542zm2.344 0h-1.173V8.391H2.344v6.073H1.172V7.192h17.656z",
    style: {
      fill: "#323233"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgType);
export default __webpack_public_path__ + "static/media/Type.d726e09d1cfbad038e2b6acdfae2af26.svg";
export { ForwardRef as ReactComponent };